<template>
  <div class="adviceBox">
    <div class="display_flex top">
      <!-- 顶部左侧 -->
      <div class="search-top">
        <el-form :inline="true" :model="formData" ref="searchForm" class="demo-form-inline">
          <el-form-item style="width:300px;">
            <el-input v-model="formData.keyword" clearable placeholder="通过名称，代码，厂家进行搜索">
              <template #suffix>
                <div @click="search" class="searchcss">
                  <i class="fa fa-search"></i>
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <!-- 顶部右侧 -->
      <div class="item">
        <el-button @click="add" class="color-green" type="primary">
          <i class="fa fa-plus-circle"></i>新增
        </el-button>
      </div>
    </div>

    <!-- 治疗项标签筛选 -->
    <!-- tabs标签页 -->
    <div>
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="药品目录" name="1">
          <div class="tables">
            <el-table v-loading="dataListLoading" :data="tableData" stripe border max-height="60vh">
              <el-table-column width="250" fixed prop="country_name" label="国家注册名称" show-overflow-tooltip />
              <el-table-column width="250" prop="country_code" label="国家药品代码" show-overflow-tooltip />
              <el-table-column width="150" prop="product_name" label="商品名称" show-overflow-tooltip />
              <el-table-column width="100" prop="reg_drug_form" label="注册剂型" show-overflow-tooltip />
              <el-table-column width="100" prop="real_drug_form" label="实际剂型" show-overflow-tooltip />
              <el-table-column width="180" prop="reg_spec" show-overflow-tooltip label="注册规格" />
              <el-table-column width="180" prop="real_spec" show-overflow-tooltip label="实际规格" />
              <el-table-column width="120" prop="package" show-overflow-tooltip label="包装材质" />
              <el-table-column width="100" prop="min_package_num" label="最小包装数" show-overflow-tooltip />
              <el-table-column width="120" prop="min_package_unit" label="最小包装单位" show-overflow-tooltip />
              <el-table-column width="100" prop="min_unit" label="最小制剂" show-overflow-tooltip />
              <el-table-column width="250" prop="company" label="药品企业" show-overflow-tooltip />
              <el-table-column width="180" prop="approval_no" label="批准文号" show-overflow-tooltip />
              <el-table-column width="180" prop="country_drug_code" show-overflow-tooltip label="药品本位码" />
              <el-table-column width="120" prop="package_company" label="分包装企业" show-overflow-tooltip />
              <el-table-column width="100" prop="on_sale" label="上市状态" show-overflow-tooltip />
              <el-table-column width="150" prop="local_code" show-overflow-tooltip label="通用名编码" />
              <el-table-column width="150" prop="local_name" show-overflow-tooltip label="药品通用名" />
              <el-table-column width="150" prop="local_drug_code" show-overflow-tooltip label="当地药品本位码" />
              <el-table-column width="200" prop="local_reg_name" show-overflow-tooltip label="药品注册名称" />
              <el-table-column width="250" prop="local_reg_name_en" show-overflow-tooltip label="英文名称" />
              <el-table-column width="120" prop="drug_type_name" label="药品类别" show-overflow-tooltip />
              <el-table-column width="120" prop="local_reg_drug_form" label="当地注册剂型" show-overflow-tooltip />
              <el-table-column width="120" prop="local_reg_drug_spec" label="当地注册规格" show-overflow-tooltip />
              <el-table-column width="200" prop="local_company" label="当地生产企业名称" show-overflow-tooltip />
              <el-table-column width="120" prop="drug_type_name" label="当地批准文号" show-overflow-tooltip />
              <el-table-column width="150" prop="drug_limit" label="当地限制用药范围" show-overflow-tooltip />
              <el-table-column width="120" prop="fee_level" label="费用等级" show-overflow-tooltip />
              <el-table-column width="120" prop="fee_type" label="收费类别" show-overflow-tooltip />
              <el-table-column width="80" align="center" prop="birth_tag" label="生育" show-overflow-tooltip />
              <el-table-column width="80" align="center" prop="citizen_tag" label="居民" show-overflow-tooltip />
              <el-table-column width="80" align="center" prop="staff_tag" label="职工" show-overflow-tooltip />
              <el-table-column width="80" align="center" prop="in_hospital_tag" label="住院" show-overflow-tooltip />
              <el-table-column width="100" align="center" prop="base_drug_tag" label="基本药品" show-overflow-tooltip />
              <el-table-column width="120" prop="staff_fee_rate" label="职工自付比例" show-overflow-tooltip />
              <el-table-column width="120" prop="citizen_fee_rate" label="居民自付比例" show-overflow-tooltip />
              <el-table-column width="120" prop="begin_time" label="生效日期" show-overflow-tooltip />
              <el-table-column width="120" prop="end_time" label="结束日期" show-overflow-tooltip />
              <el-table-column align="center" fixed="right" label="操作" width="130" >
                <template #default="scope">
                  <el-popconfirm title="是否确定导入?" @confirm="importClick(scope.row)">
                    <template #reference>
                      <el-link type="primary">导入</el-link>
                    </template>
                  </el-popconfirm>
                  <el-link type="primary" @click="modParient(scope.row)">
                    修改
                  </el-link>
                  <el-popconfirm title="是否确定删除?" @confirm="delParient(scope.row)">
                    <template #reference>
                      <el-link type="danger">
                        删除
                      </el-link>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination v-model:currentPage="pageData.currentPage" v-model:page-size="pageData.pageSize"
              :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.totalSum" @size-change="handleSizeChange"
              @current-change="handleCurrentChange"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="耗材目录" name="2">
          <div class="tables">
            <el-table border v-loading="dataListLoading" :data="tableData" stripe max-height="60vh">
              <el-table-column fixed width="250" show-overflow-tooltip prop="detail_name" label="单件产品名称" />
              <el-table-column width="150" prop="country_name" label="通用名" />
              <el-table-column width="250" prop="company" label="生产厂家" />
              <el-table-column width="200" prop="country_code" label="医保耗材代码" />
              <el-table-column width="120" prop="cate1" label="一级分类" />
              <el-table-column width="120" prop="cate2" label="二级分类" />
              <el-table-column width="150" prop="cate3" label="三级分类" />
              <el-table-column width="120" prop="spec" label="材质" />
              <el-table-column width="120" prop="speciality" label="特征" />
              <el-table-column width="200" prop="approval_no" label="注册证号" />
              <el-table-column width="200" prop="local_code" label="广州目录编码" />
              <el-table-column width="200" prop="local_name" label="广州目录名称" />
              <el-table-column width="200" prop="fee_type" label="目录等级" />
              <el-table-column width="120" prop="staff_fee_rate" label="职工自付比例" />
              <el-table-column width="120" prop="citizen_fee_rate" label="居民自付比例" />
              <el-table-column width="120" prop="fee_level" label="费用等级" />
              <el-table-column width="120" prop="fee_type" label="收费类别" />
              <el-table-column width="80" align="center" prop="birth_tag" label="生育" />
              <el-table-column width="80" align="center" prop="in_hospital_tag" label="住院" />
              <el-table-column width="80" align="center" prop="staff_tag" label="职工" />
              <el-table-column width="80" align="center" prop="citizen_tag" label="居民" />
              <el-table-column width="120" prop="statistics_type" label="统计类型" />
              <el-table-column align="center" fixed="right" label="操作" width="130" >
                <template #default="scope">
                  <el-popconfirm title="是否确定导入?" @confirm="importClick(scope.row)">
                    <template #reference>
                      <el-link type="primary">导入</el-link>
                    </template>
                  </el-popconfirm>
                  <el-link type="primary" @click="modParient(scope.row)">
                    修改
                  </el-link>
                  <el-popconfirm title="是否确定删除?" @confirm="delParient(scope.row)">
                    <template #reference>
                      <el-link type="danger">
                        删除
                      </el-link>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination v-model:currentPage="pageData.currentPage" v-model:page-size="pageData.pageSize"
              :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.totalSum" @size-change="handleSizeChange"
              @current-change="handleCurrentChange"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="治疗项目录" name="3">
          <div class="tables">
            <el-table v-loading="dataListLoading" :data="tableData" stripe border max-height="60vh">
              <el-table-column width="260" fixed show-overflow-tooltip prop="local_service_name" label="医疗服务项目名称" />
              <el-table-column width="200" show-overflow-tooltip prop="country_name" label="国家服务名称" />
              <el-table-column width="170" prop="country_code" label="国家代码" />
              <el-table-column width="170" prop="local_code" label="地方码" />
              <el-table-column width="250" prop="country_local_code" label="国家-地方码" show-overflow-tooltip />
              <el-table-column width="120" align="center" prop="staff_fee_rate" label="职工自付比例" />
              <el-table-column width="120" align="center" prop="citizen_fee_rate" label="居民自付比例" />
              <el-table-column width="100" align="center" prop="fee_level" label="费用等级" />
              <el-table-column width="100" align="center" prop="fee_type" label="收费类别" />
              <el-table-column width="80" align="center" prop="birth_tag" label="生育" />
              <el-table-column width="80" align="center" prop="in_hospital_tag" label="住院" />
              <el-table-column width="80" align="center" prop="staff_tag" label="职工" />
              <el-table-column width="80" align="center" prop="citizen_tag" label="居民" />
              <el-table-column width="120" prop="begin_time" label="生效日期" />
              <el-table-column width="120" prop="end_time" label="结束日期" />
              <el-table-column width="160" prop="remark" label="备注"  show-overflow-tooltip/>
              <el-table-column align="center" fixed="right" label="操作" width="130">
                <template #default="scope">
                  <el-popconfirm title="是否确定导入?" @confirm="importClick(scope.row)">
                    <template #reference>
                      <el-link type="primary">导入</el-link>
                    </template>
                    <span class="txfonts modify">导入</span>
                  </el-popconfirm>
                  <el-link type="primary" @click="modParient(scope.row)">
                    修改
                  </el-link>
                  <el-popconfirm title="是否确定删除?" @confirm="delParient(scope.row)">
                    <template #reference>
                      <el-link type="danger">
                        删除
                      </el-link>
                    </template>
                  </el-popconfirm>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-box">
            <el-pagination v-model:currentPage="pageData.currentPage" v-model:page-size="pageData.pageSize"
              :page-sizes="[10, 20, 50, 100]" :background="true" layout="total, sizes, prev, pager, next, jumper"
              :total="pageData.totalSum" @size-change="handleSizeChange"
              @current-change="handleCurrentChange"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 新增弹窗 -->
    <div>
      <BaseDialog :title="title" :isshow="puncture" @handleShow="handleShows" width="55%" height="auto">
        <!-- 内容-->
        <div class="addform">
          <el-form :inline="true" :model="ruleForm" ref="searchForm" class="demo-form-inline w-144">
            <el-form-item label="生效日期：" v-if="activeName != '2'">
              <el-date-picker v-model="ruleForm.begin_time" type="date" placeholder="生效日期" value-format="YYYY-MM-DD" />
            </el-form-item>
            <el-form-item label="结束日期：" v-if="activeName != '2'">
              <el-date-picker v-model="ruleForm.end_time" type="date" placeholder="结束日期" value-format="YYYY-MM-DD" />
            </el-form-item>
            <el-form-item label="商品名称 " v-if="activeName == '1'">
              <el-input v-model="ruleForm.product_name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="国家名称:" v-if="activeName == '1'">
              <el-input v-model="ruleForm.country_name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="国家药品代码:" v-if="activeName == '1'">
              <el-input v-model="ruleForm.country_code" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="国家服务名称:" v-if="activeName == '3'">
              <el-input v-model="ruleForm.country_name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="实际剂型:" v-if="activeName == '1'">
              <el-input v-model="ruleForm.real_drug_form" placeholder="请输入" />
              <!-- <el-select v-model="ruleForm.real_drug_form">
                <el-option v-for="item in dictList[164000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="注册剂型:" v-if="activeName == '1'">
              <el-input v-model="ruleForm.reg_drug_form" placeholder="请输入" />
              <!-- <el-select v-model="ruleForm.real_drug_form">
                <el-option v-for="item in dictList[164000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select> -->
            </el-form-item>
            <el-form-item label="注册规格：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.reg_spec" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="实际规格：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.real_spec" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="包装材质：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.package" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="最小包装数：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.min_package_num" placeholder="最小包装数" />
            </el-form-item>
            <el-form-item label="最小包装单位：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.min_package_unit" placeholder="最小包装单位" />
            </el-form-item>
            <el-form-item label="最小制剂：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.min_unit" placeholder="最小制剂" />
            </el-form-item>

            <el-form-item label="药品企业：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.company" placeholder="药品企业" />
            </el-form-item>
            <el-form-item label="批准文号：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.approval_no" placeholder="批准文号" />
            </el-form-item>
            <el-form-item label="药品本位码：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.county_drug_code" placeholder="药品本位码" />
            </el-form-item>
            <el-form-item label="分包装企业：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.package_company" placeholder="分包装企业" />
            </el-form-item>
            <el-form-item label="上市状态：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.on_sale" placeholder="上市状态" />
            </el-form-item>
            <el-form-item label="药品通用名编码：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_code" placeholder="药品通用名编码" />
            </el-form-item>
            <el-form-item label="药品通用名：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_name" placeholder="药品通用名" />
            </el-form-item>
            <el-form-item label="当地药品本位码：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_drug_code" placeholder="当地药品本位码" />
            </el-form-item>
            <el-form-item label="药品注册名称：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_reg_name" placeholder="药品注册名称" />
            </el-form-item>
            <el-form-item label="英文名称：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_reg_name_en" placeholder="英文名称" />
            </el-form-item>
            <el-form-item label="药品类别：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.drug_type_name" placeholder="药品类别" />
            </el-form-item>
            <el-form-item label="当地注册剂型：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_reg_drug_form" placeholder="当地注册剂型" />
            </el-form-item>
            <el-form-item label="当地注册规格：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_reg_drug_spec" placeholder="当地注册规格" />
            </el-form-item>
            <el-form-item label="当地批准文号：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.drug_type_name" placeholder="当地批准文号" />
            </el-form-item>
            <el-form-item label="当地生产企业名称：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.local_company" placeholder="当地生产企业名称" />
            </el-form-item>
            <el-form-item label="当地限制用药范围：" v-if="activeName == '1'">
              <el-input v-model="ruleForm.drug_limit" placeholder="当地限制用药范围" />
            </el-form-item>
            <el-form-item label="基本药品：" v-if="activeName == '1'">
              <el-select v-model="ruleForm.base_drug_tag">
                <el-option v-for="item in typeChangeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <!-- 以上是1药品 -->
            <el-form-item label="通用名:" v-if="activeName == '2'">
              <el-input v-model="ruleForm.country_name" placeholder="通用名" />
            </el-form-item>
            <el-form-item label="单件产品名称: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.detail_name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="医保耗材代码: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.country_code" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="一级分类:" v-if="activeName == '2'">
              <el-input v-model="ruleForm.cate1" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="二级分类:" v-if="activeName == '2'">
              <el-input v-model="ruleForm.cate2" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="三级分类:" v-if="activeName == '2'">
              <el-input v-model="ruleForm.cate3" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="材质:" v-if="activeName == '2'">
              <el-input v-model="ruleForm.spec" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="特征: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.speciality" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="注册证号: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.approval_no" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="广州目录编码: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.local_code" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="广州目录名称: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.local_name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="目录等级: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.fee_type" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="生产厂家: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.company" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="统计类型: " v-if="activeName == '2'">
              <el-input v-model="ruleForm.statistics_type" placeholder="请输入" />
            </el-form-item>
            <!-- 以上是2 -->
            <el-form-item label="医疗服务项目名称:" v-if="activeName == '3'">
              <el-input v-model="ruleForm.local_service_name" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="国家代码:" v-if="activeName == '3'">
              <el-input v-model="ruleForm.country_code" placeholder="请输入" />
            </el-form-item>
            <el-form-item label="地方码:" v-if="activeName == '3'">
              <el-input v-model="ruleForm.local_code" placeholder="请输入" />
            </el-form-item>
            <!-- <el-form-item label="支付类型:" v-if="activeName == '3'">
              <el-select v-model="ruleForm.payment_type">
                <el-option v-for="item in dictList[160000000]" :key="item.id" :label="item.name"
                  :value="item.code"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="费用等级：">
              <el-input v-model="ruleForm.fee_level" placeholder="费用等级" />
            </el-form-item>
            <el-form-item label="收费类别：">
              <el-input v-model="ruleForm.fee_type" placeholder="收费类别" />
            </el-form-item>
            <el-form-item label="是否用于生育:">
              <el-select v-model="ruleForm.birth_tag">
                <el-option v-for="item in typeChangeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否属于居民：">
              <el-select v-model="ruleForm.citizen_tag">
                <el-option v-for="item in typeChangeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否属于职工">
              <el-select v-model="ruleForm.staff_tag">
                <el-option v-for="item in typeChangeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否属于住院：">
              <el-select v-model="ruleForm.in_hospital_tag">
                <el-option v-for="item in typeChangeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="职工自付比例：">
              <el-input v-model="ruleForm.staff_fee_rate" placeholder="职工自付比例" />
            </el-form-item>
            <el-form-item label="居民自付比例：">
              <el-input v-model="ruleForm.citizen_fee_rate" placeholder="居民自付比例" />
            </el-form-item>
            <!-- <el-form-item label="是否启用：">
              <el-switch v-model="ruleForm.is_enable" inline-prompt active-text="是" inactive-text="否" />
            </el-form-item> -->
            <el-form-item label="备注：" v-if="activeName == '3'" style="width: 100% !important">
              <el-input v-model="ruleForm.remark" :autosize="{ minRows: 2, maxRows: 4 }" type="textarea"
                placeholder="请输入" />
            </el-form-item>
            <!-- <el-form-item label="药品标签：" style="width: 100% !important" v-if="activeName == '1'">
              <div class="parienttag">
                <div :class="item.active ? 'tags' : 'tag'" v-for="item in lists" :key="item.id" @click="tabgse(item)">
                  {{ item.name }}
                </div>
              </div>
            </el-form-item>
            <el-form-item label="药品标签：" style="width: 100% !important" v-if="activeName == '3'">
              <div class="parient-tag">
                <el-tag :class="item.active ? 'active' : ''" v-for="item in doclists" :key="item.id"
                  @click="tabios(item)">{{ item.name }}</el-tag>
              </div>
            </el-form-item> -->
          </el-form>

          <!-- 缺少标签 -->
          <!-- <div style="color: #3166ae; margin: 0 20px; display: flex" v-if="activeName !== '2'">
            <div class="faicon">
              <i class="fa fa-question-circle-o icou1"></i>
            </div>
            <div style="margin-top: 4px">缺少标签，立即查看</div>
          </div>-->
        </div>

        <el-divider />
        <div style="text-align: right">
          <el-button @click="cancel">取消</el-button>
          <el-button type="primary" @click="Confirmpuncture" :loading="saveLoad">确定</el-button>
        </div>
      </BaseDialog>
    </div>
  </div>
</template>

<script>
import { toRefs, reactive, onMounted, ref } from 'vue'
import service from '@/utils/request'
import BaseDialog from '@/components/Dialog/index.vue'
import { gitDictList } from '@/utils/tool'
import { ElMessage } from 'element-plus'
export default {
  components: {
    BaseDialog,
  },
  setup() {
    const state = reactive({
      ruleForm: {
        birth_tag: '',
        citizen_tag: '',
        staff_tag: '',
        in_hospital_tag: ''
      },
      tags: [],
      formData: {
        status: '',
      },
      title: '',
      dictList: {},
      tableData: [],
      listop: [],
      lists: [],
      doclist: [],
      doclists: [],
      puncture: false,
      saveLoad: false,
      ruleFormRef: null,
      isRecord: false,
      dict_type: '',
      activeName: '1',
      tableHei: '',
      disabled: false,
      dict_advice_type: '',
      dict_catalog_type: '',
      pageData: {
        currentPage: 1,
        pageSize: 20,
        totalSum: 0,
      },
      typeChangeList: [{
        id: '属于',
        name: '属于',
        value: '1'
      }, {
        id: '不属于',
        name: '不属于',
        value: '0'
      }],
      conmons: [],
    })
    onMounted(() => {
      initData()
      tobody()
    })
    // tabs标签页点击事件
    const handleClick = (e) => {
      state.activeName = JSON.parse(JSON.stringify(e.props.name))
      state.pageData.currentPage = 1
      tobody()
    }
    // 改变联机选择
    const props = {
      label: 'name',
      value: 'code',
      children: 'childrenItems',
    }
    // 弹窗关闭
    const handleShows = (val) => {
      console.log(val)
      if (!val) {
        state.ruleForm = {
          is_enable: true,
        }
        state.disabled = false

        state.dictList[332900000].forEach((item) => {
          item.active = false
        })
      }
      state.puncture = val
    }
    // 新增
    const add = () => {
      state.puncture = true
      switch (state.activeName) {
        case '1':
          state.title = '新增药品';
          break;
        case '2':
          state.title = '新增耗材';
          break;
        case '3':
          state.title = '新增治疗项';
          break;
      }
    }
    const timeChange = (e) => {
      console.log(e)
      state.ruleForm.time = e
    }
    // 当条数改变时
    const handleSizeChange = (e) => {
      state.pageData.pageSize = e
      tobody()
    }
    // 当页数改变时
    const handleCurrentChange = (e) => {
      state.pageData.currentPage = e
      tobody()
    }
    // 获取字典
    const initData = async () => {
      state.dictList = await gitDictList([
        '332900000',
        '210000000',
        '103000000',
        '160000000',
        '116000000',
        '176000000',
        '231000000',
        '157000000',
        '158000000',
        '159000000',
        '339600000',
        '164000000',
        '113000000',
        '161000000',
        '100000000',
        '340200000',
        '339600000',
      ])
      state.dictList[332900000].forEach((item) => {
        item.active = false
      })
      state.listop = state.dictList[332900000]
      state.lists = JSON.parse(JSON.stringify(state.dictList[332900000]))
      // 治疗项
      state.dictList[340200000].forEach((item) => {
        item.active = false
      })
      state.doclist = state.dictList[340200000]
      state.doclists = JSON.parse(JSON.stringify(state.dictList[340200000]))
    }
    // 获取列表
    const tobody = async () => {
      let url = ''
      if (state.activeName == '1') {
        url = '/api/drug/base_drug_list'
      } else if (state.activeName == '2') {
        url = '/api/drug/base_haocai_list'
      } else if (state.activeName == '3') {
        url = '/api/drug/base_service_list'
      }
      let data = {
        current: state.pageData.currentPage,
        size: state.pageData.pageSize,
        keyword: state.formData.keyword,
      }
      let res = await service.post(url, data)
      if (res.code === 0) {
        if (res.data.total > 0) {
          state.tableData = res.data.list
          state.pageData.totalSum = res.data.total
        } else {
          state.pageData.totalSum = 0
          state.tableData = []
        }
      }
    }
    // 停用/在用选择框
    const selectchan = () => {
      tobody()
    }
    // 选择种类
    const type = () => {
      tobody()
    }
    // 新增确定
    const Confirmpuncture = async () => {
      state.saveLoad = true
      let url = ""
      let urlUpdate = ''
      if (state.activeName == '1') {
        url = "/api/drug/base_drug_create"
        urlUpdate = '/api/drug/base_drug_edit'
      } else if (state.activeName == '2') {
        url = "/api/drug/base_haocai_create"
        urlUpdate = '/api/drug/base_haocai_edit'
      } else if (state.activeName == '3') {
        url = "/api/drug/base_service_create"
        urlUpdate = '/api/drug/base_service_edit'
      }
      if (!state.ruleForm.id) {
        let res = await service.post(url, state.ruleForm)
        if (res.code == 0) {
          state.saveLoad = false
          ElMessage({
            message: '保存成功',
            type: 'success',
          })
          tobody()
          state.puncture = false
          state.disabled = false
          state.ruleForm = {}
        }else{
          state.saveLoad = false
        }
      } else {
        let res = await service.post(urlUpdate, state.ruleForm)
        if (res.code == 0) {
          state.saveLoad = false
          ElMessage({
            message: '修改成功',
            type: 'success',
          })
          tobody()
          state.disabled = false
          state.puncture = false
          state.ruleForm = {}
        }else{
          state.saveLoad = false
        }
      }
    }
    // 导入
    const importClick = async (row) => {
      let url = '/api/drug/import_drug'
      switch (state.activeName) {
        case '1':
          url = '/api/drug/import_drug'
          break;
        case '2':
          url = '/api/drug/import_haocai'
          break;
        case '3':
          url = '/api/drug/import_service'
          break;
      }
      let res = await service.post(url, { 'id': row.id })
      if (res.code == 0) {
        ElMessage({
          message: '导入',
          type: 'success',
        })
      }
    }
    // 表格修改
    const modParient = (row) => {
      state.ruleForm = JSON.parse(JSON.stringify(row))
      if (row.is_enable == 1) {
        state.ruleForm.is_enable = true
      } else {
        state.ruleForm.is_enable = false
      }
      console.log(state.ruleForm)
      state.disabled = true
      state.puncture = true
      switch (state.activeName) {
        case '1':
          state.title = '修改药品';
          break;
        case '2':
          state.title = '修改耗材';
          break;
        case '3':
          state.title = '修改治疗项';
          break;
      }
    }
    //删除
    const delParient = async (row) => {
      let url = ''
      if (state.activeName == '1') {
        url = '/api/drug/base_drug_delete'
      } else if (state.activeName == '2') {
        url = '/api/drug/base_haocai_delete'
      } else {
        url = '/api/drug/base_service_delete'
      }
      let res = await service.post(url, { id: row.id })
      if (res.code == 0) {
        ElMessage({
          message: '删除成功',
          type: 'success',
        })
        tobody()
      }
    }
    //停用
    const deatilsClick = async (row) => {
      let res = await service.post('/api/drug/stop', { id: row.id })
      if (res.code == 0) {
        ElMessage({
          message: '停用成功',
          type: 'success',
        })
        tobody()
      }
    }
    // 搜索
    const search = () => {
      tobody()
    }
    // 药品标签弹窗选择
    const tabgse = (row) => {
      console.log(row)
      row.active = !row.active
      let tabList = []
      const item = state.lists
      for (let i = 0; i < item.length; i++) {
        if (item[i].active) {
          tabList.push(item[i].code)
        }
      }
      state.ruleForm.tag = tabList
    }
    // 治疗项弹窗标签选择
    const tabios = (row) => {
      row.active = !row.active
      let tabList = []
      const item = state.doclists
      for (let i = 0; i < item.length; i++) {
        if (item[i].active) {
          tabList.push(item[i].code)
        }
      }
      state.ruleForm.tag = tabList
    }
    const tagBut = (row) => {
      console.log(row)
      row.active = !row.active
      let tabList = []
      const item = state.listop
      for (let i = 0; i < item.length; i++) {
        if (item[i].active) {
          tabList.push(item[i].code)
        }
      }
      state.tags = tabList
      tobody()
    }
    const tagButs = (row) => {
      console.log(row)
      row.active = !row.active
      let tabList = []
      const item = state.doclist
      for (let i = 0; i < item.length; i++) {
        if (item[i].active) {
          tabList.push(item[i].code)
        }
      }
      state.tags = tabList
      tobody()
    }
    // 弹窗取消
    const cancel = () => {
      state.puncture = false
    }
    let handleprops = ref('')
    handleprops = {
      lazy: true,
      value: 'code',
      label: 'name',
      async lazyLoad(node, resolve) {
        const { value, level } = node
        let nodes = []
        let codes = ''
        if (level === 0) {
          codes = '339600000'
        } else {
          codes = value
        }
        let res = await gitDictList([codes])
        state.list = res[codes]
        nodes = res[codes]
        nodes.map(function (item) {
          item.leaf = level >= 2
        })
        resolve(nodes)
      },
    }
    return {
      ...toRefs(state),
      handleClick,
      search,
      initData,
      cancel,
      tobody,
      props,
      Confirmpuncture,
      tagBut,
      tabgse,
      tabios,
      handleCurrentChange,
      handleSizeChange,
      timeChange,
      modParient,
      importClick,
      delParient,
      handleShows,
      add,
      type,
      selectchan,
      handleprops,
      tagButs,
    }
  },
}
</script>

<style scoped lang="scss">
.adviceBox {
  height: 100%;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  padding: 10px;
}

.demo-tabs>.el-tabs__content {
  padding: 32px;
  color: #6b778c;
  font-size: 32px;
  font-weight: 600;
}

.display_flex {
  display: flex;
  justify-content: space-between;
}

.search-top .w-208 {
  width: 208px;

  .searchcss {
    cursor: pointer;
  }
}

.faicon {
  font-size: 19px;
  margin-right: 6px;
  cursor: pointer;
}

.tabclis {
  height: 32px;
  background: rgba(49, 102, 174, 0.1);
  border-radius: 8px 8px 8px 8px;
  opacity: 1;
  display: flex;
  padding: 3px;

  .tabclis_right {
    display: flex;
    padding-top: 2px;
  }
}

.addform {
  .el-form {
    display: flex;
    flex-wrap: wrap;

    &:deep(.el-form-item__label) {
      width: 150px !important;
      text-align: right;
    }

    &:deep(.el-input) {
      width: 200px !important;
    }

    &:deep(.el-form-item) {
      width: 45% !important;
    }

    .mt_4 {
      &:deep(.el-input) {
        width: 100px !important;
      }
    }

    .parienttag {
      width: 100%;
      display: flex;
      flex-wrap: wrap;

      .tag {
        margin-right: 8px;
        margin-bottom: 8px;
        color: #409eff;
        background-color: #ecf5ff;
        height: 20px;
        line-height: 20px;
        border-radius: 3px;
        text-align: center;
        font-size: 12px;
        padding: 0 10px;
        cursor: pointer;
      }

      .tags {
        margin-right: 8px;
        margin-bottom: 8px;
        background: #409eff;
        color: #ffffff;
        border-radius: 3px;
        height: 20px;
        line-height: 20px;
        text-align: center;
        font-size: 12px;
        padding: 0 10px;
        cursor: pointer;
      }
    }
  }
}

.pagination-box {
  &:deep(.el-input__inner) {
    padding-right: 15px !important;
  }
}

.w-144 {
  margin-top: 20px;
}

.stop {
  background-color: #f4a939;
}

.modify {
  background-color: #3166ae;
}

.del {
  background-color: #ffecec;
  color: #ff6b6b;
  font-weight: 700;
}

.top {
  height: 35px;
  margin: 8px 0;
}
</style>

<style scoped>
.el-input-group__append .el-select>>>.el-input__inner {
  border: none !important;
}

.el-form.w-144 .el-select {
  width: 150px !important;
}
</style>
